module.exports = __webpack_public_path__ + "img/undraw_Completed_steps.d8e87def.svg";